import { render, staticRenderFns } from "./TypeSettings.vue?vue&type=template&id=5ae5e597&"
import script from "./TypeSettings.vue?vue&type=script&lang=js&"
export * from "./TypeSettings.vue?vue&type=script&lang=js&"
import style0 from "./TypeSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports